import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { CREATE_PLC_SAFETY_TRIGGER } from './actionTypes';
import { createPlcSafetyTriggerSuccessful, createPlcSafetyTriggerFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* createTrigger({ payload: { trigger } }) {
  try {
    const response = yield call(plcSafetyAPI.createTrigger, trigger.token, trigger);
    if (response.message) {
      yield put(createPlcSafetyTriggerSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(createPlcSafetyTriggerFailed(error));
  }
}

export function* watchCreatePlcSafetyTrigger() {
  yield takeEvery(CREATE_PLC_SAFETY_TRIGGER, createTrigger);
}

function* createPlcSafetyTriggerSaga() {
  yield all([fork(watchCreatePlcSafetyTrigger)]);
}

export default createPlcSafetyTriggerSaga;
